/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('age-verification-pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class AgeVerificationPopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;
        this.closeButtons = this.querySelectorAll('.js-close-modal');
        this.closeBehavior = this.dataset.closeBehavior || 'just_close';
        this.closeDays = parseInt(this.dataset.closeDays || '7', 10);

        // 모든 닫기 버튼에 이벤트 리스너 추가
        this.closeButtons.forEach(button => {
          button.addEventListener('click', this.handleCloseClick.bind(this));
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie)) {
          this.open();
        }
      }

      /**
       * Opens the modal.
       * @param {Element} opener - Modal opener element.
       */
      open(opener) {
        super.open(opener);
        this.removeEventListener('keyup', this.keyupHandler);
      }

      /**
       * Handle the close button click
       * @param {Event} evt - Click event
       */
      handleCloseClick(evt) {
        const button = evt.currentTarget;
        const closeType = button.dataset.closeType || this.closeBehavior;
        const customDays = parseInt(button.dataset.closeDays || this.closeDays, 10);

        let cookieDays = 0;

        switch (closeType) {
          case 'today':
            // 오늘 하루 보지 않기 - 자정까지
            const now = new Date();
            const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
            const hoursUntilMidnight = (tomorrow - now) / (1000 * 60 * 60);
            cookieDays = hoursUntilMidnight / 24;
            break;
          
          case 'forever':
            // 다시 보지 않기 - 10년
            cookieDays = 3650;
            break;
          
          case 'custom':
            // 커스텀 기간
            cookieDays = customDays;
            break;
          
          case 'just_close':
          default:
            // 그냥 닫기 - 쿠키 없음
            cookieDays = 0;
            break;
        }

        // 쿠키 설정 (days > 0 일 때만)
        if (cookieDays > 0) {
          setCookie(this.cookie, true, cookieDays);
        }

        // 팝업 닫기
        this.close();
      }

      /**
       * Handles 'click' events on the modal.
       * @param {object} evt - Event object.
       */
      handleClick(evt) {
        // 오버라이드: 기본 닫기 동작 방지
        // 닫기는 handleCloseClick에서만 처리
        if (evt.target.matches('.js-close-modal')) {
          // handleCloseClick에서 처리되므로 여기서는 아무것도 하지 않음
          return;
        }
        
        // 모달 배경 클릭 시 처리 (선택사항)
        if (evt.target === this && this.closeBehavior !== 'age-gate') {
          this.handleCloseClick(evt);
        }
      }
    }

    customElements.define('age-verification-pop-up', AgeVerificationPopUp);
  });
}
